let $quantityProductsInStiffnessComparison = $('#quantityProductsInStiffnessComparison'),
    $quantityProductsCompared = $('#quantityProductsCompared'),
    $quantityFavoritesProducts = $('.js-quantity-favorites-products'),
    $quantityProductsInCart = $('.js-quantity-products-in-cart');

export default function updateCounters(quantityProductsInStiffnessComparison = undefined,
                                       quantityProductsCompared = undefined,
                                       quantityFavoritesProducts = undefined,
                                       quantityProductsInCart = undefined
) {
    if ($.isNumeric(quantityProductsInStiffnessComparison)) {
        $quantityProductsInStiffnessComparison.attr('data-value', quantityProductsInStiffnessComparison);
    }

    if ($.isNumeric(quantityProductsCompared)) {
        $quantityProductsCompared.attr('data-value', quantityProductsCompared);
    }

    if ($.isNumeric(quantityFavoritesProducts)) {
        $quantityFavoritesProducts.attr('data-value', quantityFavoritesProducts);
    }

    if ($.isNumeric(quantityProductsInCart)) {
        $quantityProductsInCart.attr('data-value', quantityProductsInCart);
    }
}